(function ($, window, document, undefined) {
    document.addEventListener("CoveoSearchEndpointInitialized", function () {
        //var externalComponentsSection = document.getElementById("_544D3067-509B-4CAE-AE48-15551B4FEECA");
        //CoveoForSitecore.initExternalComponentsSection(externalComponentsSection);

        var root = document.querySelector("#SpotlightSearchInterface");
        if (root == null) {
            root = document.querySelector("#_544D3067-509B-4CAE-AE48-15551B4FEECA");
        }
        if (root != null) {
            Coveo.$$(root).on("afterComponentsInitialization", function (e, args) {
                var coveoOmniBox = $(".CoveoOmnibox");
                if (coveoOmniBox.length > 0) {
                    $.each(coveoOmniBox, function (key, val) {
                        if ($(this).length > 0) {
                            $(this).attr("aria-controls", "_544D3067-509B-4CAE-AE48-15551B4FEECA");
                            $(this).attr("aria-labelledby", "SearchField" + key);
                            if ($(this).find("input[form='coveo-dummy-form']").length > 0) {
                                $(this).find("input[form='coveo-dummy-form']").attr("id", "SearchField" + key);
                            }
                        }
                    });
                }
                //Prevent users from typing Opening or Closing Html tag
                if ($(".CoveoOmnibox input").length > 0) {
                    $(".CoveoOmnibox input").on("keydown", function (e) {
                        if (e.shiftKey && (e.which == 188 || e.which == 190)) {
                            e.preventDefault();
                        }
                    });
                }
                if ($("#_544D3067-509B-4CAE-AE48-15551B4FEECA .CoveoOmnibox input").length > 0) {
                    $("#_544D3067-509B-4CAE-AE48-15551B4FEECA .CoveoOmnibox input").on('keyup', function (e) {
                        $(this).val($("#_544D3067-509B-4CAE-AE48-15551B4FEECA .CoveoOmnibox input").val().replace(/<|>/g, ''));
                    });
                }
                if ($("#SpotlightSearchInterface .CoveoOmnibox input").length > 0) {
                    $("#SpotlightSearchInterface .CoveoOmnibox input").on('keyup', function (e) {
                        $(this).val($("#SpotlightSearchInterface .CoveoOmnibox input").val().replace(/<|>/g, ''));
                    });
                }
                if ($("#SubzeroSearchInterface .CoveoOmnibox input").length > 0) {
                    $("#SubzeroSearchInterface .CoveoOmnibox input").on('keyup', function (e) {
                        $(this).val($("#SubzeroSearchInterface .CoveoOmnibox input").val().replace(/<|>/g, ''));
                    });
                }
                if ($('.coveo-custom-sort-dropdown-picker').length > 0) {
                    $('.coveo-custom-sort-dropdown-picker').each(function () {
                        var randomValue = Math.floor(Math.random() * 100);
                        $(this).attr('aria-label', 'coveo-sort-dropdown' + randomValue);
                        $(this).parent().attr('id', 'coveo-sort-dropdown' + randomValue);
                    });
                }
            });
        }
    });
})(window.jQuery, this, this.document);